<template>
  <sweet-modal
    ref="modal"
    @close="setOpenSaveModal(false)"
    @class="vld - parent"
    hide-close-button
  >
    <loading :active="savingTemplate" :is-full-page="false"></loading>
    <div class="form-horizontal">
      <div class="form-group">
        <label for="templateName" class="col-xs-3 control-label">{{
          $t('modals.template_name')
        }}</label>
        <div class="col-xs-9">
          <input
            class="form-control"
            type="text"
            :placeholder="$t('modals.template_name')"
            :value="templateName"
            @input="setTemplateName"
          />
        </div>
      </div>
      <div class="form-group" v-if="canSelectDestinationLibrary">
        <library-selector />
      </div>
    </div>
    <template #button>
      <button class="btn btn-default right-margin" @click="close">
        {{ $t('modals.close_button') }}
      </button>
      <button class="btn btn-primary" id="save-designer" @click="saveTemplate">
        {{ $t('modals.save_button') }}
      </button>
    </template>
  </sweet-modal>
</template>

<script>
import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
import {SweetModal} from 'sweet-modal-vue-3';
import LibrarySelector from './LibrarySelector';
import Loading from 'vue-loading-overlay';

export default {
  name: 'SaveTemplateModal',
  components: {
    SweetModal,
    LibrarySelector,
    Loading
  },
  computed: {
    ...mapState({
      openSaveModal: state => state.openSaveModal,
      templateName: state => state.templateName,
      savingTemplate: state => state.savingTemplate,
      success: state => state.success
    }),
    ...mapGetters(['canSelectDestinationLibrary'])
  },
  methods: {
    setTemplateName: function (e) {
      this.$store.commit('setTemplateName', e.target.value);
    },
    close: function () {
      this.$refs.modal.close();
    },
    ...mapMutations(['setOpenSaveModal', 'setSuccess']),
    ...mapActions(['saveTemplate'])
  },
  watch: {
    success: function (newValue) {
      if (newValue !== undefined && newValue === true) {
        this.$refs.modal.close();
      }
    },
    openSaveModal: function (newValue) {
      if (newValue === true) {
        this.setSuccess(false);
        this.$refs.modal.open();
      }
    }
  }
};
</script>

<style scoped>
.right-margin {
  margin-right: 1em;
}
</style>
